var _circle, _circle2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFailed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 172,
    height: 172,
    viewBox: "0 0 172 172",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 86,
    cy: 86,
    r: 86,
    fill: "#EC1A1A",
    fillOpacity: 0.1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 86,
    cy: 86,
    r: 64.5,
    fill: "#EC1A1A",
    fillOpacity: 0.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.051 118.25C106.695 118.25 104.34 117.354 102.549 115.551L56.4459 69.4495C52.8514 65.8551 52.8514 60.0402 56.4459 56.4458C60.0404 52.8514 65.8554 52.8514 69.4498 56.4458L115.553 102.547C119.147 106.142 119.147 111.957 115.553 115.551C113.762 117.354 111.406 118.25 109.051 118.25Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.9496 118.25C60.5941 118.25 58.2387 117.354 56.4476 115.551C52.8531 111.957 52.8531 106.142 56.4476 102.547L102.55 56.4458C106.145 52.8514 111.96 52.8514 115.554 56.4458C119.149 60.0402 119.149 65.8551 115.554 69.4495L69.4516 115.551C67.6604 117.354 65.305 118.25 62.9496 118.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailed);
export default __webpack_public_path__ + "static/media/Failed.75560d3740f31ad95f6e0e1b6b9e6ca6.svg";
export { ForwardRef as ReactComponent };